var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox lucky-wheel-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "page-title" }, [_vm._v("活动管理")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-wrap" },
            [
              _c(
                "el-input",
                {
                  staticClass: "keyword-input",
                  attrs: {
                    placeholder: "请输入活动id/活动名称",
                    size: "small",
                    clearable: "",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch($event)
                    },
                  },
                  model: {
                    value: _vm.query.keyword,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "keyword", $$v)
                    },
                    expression: "query.keyword",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.handleSearch },
                    slot: "append",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("活动状态：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "select-box",
                      attrs: { size: "small", placeholder: "全部" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "未开始", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "进行中", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "已结束", value: 2 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("排序：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "sort-box",
                      attrs: { size: "small" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.sort,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "sort", $$v)
                        },
                        expression: "query.sort",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "按更新时间降序排列",
                          value: "update_desc",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          label: "按更新时间升序排列",
                          value: "update_asc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleReset } },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tool-wrap" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:activity:luckywheel:activity:save"],
                      expression: "['admin:activity:luckywheel:activity:save']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.goCreate },
                },
                [_vm._v("添加活动")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "lucky-wheel-table",
              attrs: {
                data: _vm.tableData,
                size: "small",
                border: "",
                "highlight-current-row": "",
                "header-cell-style": {
                  fontWeight: "bold",
                  background: "#f5f7fa",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "活动id", "min-width": "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "activityName",
                  label: "活动名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "适用分销客户", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              effect: "dark",
                              "popper-class": "lucky-wheel-customer-tooltip",
                              "open-delay": 200,
                              disabled: !_vm.formatCustomers(scope.row),
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(_vm.formatCustomers(scope.row)))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "customer-clamp" }, [
                              _vm._v(
                                _vm._s(_vm.formatCustomers(scope.row) || "—")
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动时间", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "time-line" }, [
                          _c("span", { staticClass: "time-prefix" }, [
                            _vm._v("起"),
                          ]),
                          _vm._v(_vm._s(scope.row.startTime || "—")),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "time-line" }, [
                          _c("span", { staticClass: "time-prefix" }, [
                            _vm._v("止"),
                          ]),
                          _vm._v(_vm._s(scope.row.endTime || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "活动状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTagType(scope.row.status),
                              size: "small",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.statusDesc || "—"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "170",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "180", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        Number(scope.row.status) !== 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:activity:luckywheel:activity:info",
                                    ],
                                    expression:
                                      "['admin:activity:luckywheel:activity:info']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Number(scope.row.status) === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:activity:luckywheel:activity:update",
                                    ],
                                    expression:
                                      "['admin:activity:luckywheel:activity:update']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:activity:luckywheel:activity:copy",
                                ],
                                expression:
                                  "['admin:activity:luckywheel:activity:copy']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                        _vm._v(" "),
                        Number(scope.row.status) === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:activity:luckywheel:activity:delete",
                                    ],
                                    expression:
                                      "['admin:activity:luckywheel:activity:delete']",
                                  },
                                ],
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Number(scope.row.status) === 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:activity:luckywheel:activity:end",
                                    ],
                                    expression:
                                      "['admin:activity:luckywheel:activity:end']",
                                  },
                                ],
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEnd(scope.row)
                                  },
                                },
                              },
                              [_vm._v("结束")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("template", { slot: "empty" }, [
                _vm.showAddEmptyBlock
                  ? _c(
                      "div",
                      { staticClass: "empty-wrap" },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "empty-box",
                            attrs: {
                              viewBox: "0 0 79 86",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c(
                              "defs",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "lucky-wheel-empty-a",
                                      x1: "38%",
                                      y1: "0%",
                                      x2: "62%",
                                      y2: "100%",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      attrs: {
                                        "stop-color": "#FCFCFD",
                                        offset: "0%",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("stop", {
                                      attrs: {
                                        "stop-color": "#F0F1F3",
                                        offset: "100%",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M31.5 3.5L3.5 18.2v29.6L31.5 62.5l28-14.7V18.2z",
                                fill: "url(#lucky-wheel-empty-a)",
                                stroke: "#DCDFE6",
                                "stroke-width": "1.2",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M31.5 62.5V33.8L3.5 18.2",
                                fill: "none",
                                stroke: "#DCDFE6",
                                "stroke-width": "1.2",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M31.5 33.8L59.5 18.2",
                                fill: "none",
                                stroke: "#DCDFE6",
                                "stroke-width": "1.2",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M20 10.5l28 14.7",
                                fill: "none",
                                stroke: "#E4E7ED",
                                "stroke-width": "1",
                              },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: {
                                cx: "62",
                                cy: "8",
                                r: "1.4",
                                fill: "#C0C4CC",
                              },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: {
                                cx: "70",
                                cy: "16",
                                r: "1.1",
                                fill: "#DCDFE6",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M67 4l1.6 1.6M67 5.6L68.6 4",
                                stroke: "#C0C4CC",
                                "stroke-width": "1",
                                "stroke-linecap": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M12 72l1.4 1.4M12 73.4L13.4 72",
                                stroke: "#DCDFE6",
                                "stroke-width": "1",
                                "stroke-linecap": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:activity:luckywheel:activity:save",
                                ],
                                expression:
                                  "['admin:activity:luckywheel:activity:save']",
                              },
                            ],
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.goCreate },
                          },
                          [_vm._v("去添加")]
                        ),
                      ],
                      1
                    )
                  : _c("span", { staticClass: "el-table__empty-text" }, [
                      _vm._v("暂无数据"),
                    ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm.total > 0
            ? _c(
                "div",
                { staticClass: "table-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageData.page,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageData.limit,
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handlePageChange,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }